import React from 'react';
import { Typography } from '@mui/material';
import type { FormSchemaV3 } from '../../../../../../../types/preloan/v3';
import HTMLParser from '../../../../../../../components/HTMLParser';

type HeaderProps ={
    formSchema: FormSchemaV3,
}

export default function Header(props:HeaderProps) {
  const { formSchema } = props;
  return (
    <>
      <Typography component="div" variant="body1" align="center" style={{ fontWeight: 'bold', marginBottom: 20 }} gutterBottom>
        {formSchema.config.preLoanRequestConfig?.rejectedStepText?.header && (
          <HTMLParser html={formSchema.config.preLoanRequestConfig?.rejectedStepText?.header} />
        )}
      </Typography>
      <Typography gutterBottom align="center" variant="body2" component="div">
        {formSchema.config.preLoanRequestConfig?.rejectedStepText?.body && (
          <HTMLParser html={formSchema.config.preLoanRequestConfig?.rejectedStepText?.body} />
        )}
      </Typography>
    </>
  );
}
